import { useCallback } from "react"

import { POWUR_CARE_WARRANTY_FAMILY } from "@logic/lib/constants"
import { useSetRecoilState } from "recoil"

import type { Design } from "./design-model"
import { designLocalState, designRemoteState } from "./design-state"

export type ExtendedWarrantySnapshot = Pick<
  Design,
  | `extendedWarrantyCost`
  | `extendedWarrantyFamily`
  | `extendedWarrantyName`
  | `extendedWarrantyPowurOsId`
  | `extendedWarrantySpanishName`
>

export const CLEARED_EXTENDED_WARRANTY_SNAPSHOT: ExtendedWarrantySnapshot = {
  extendedWarrantyPowurOsId: null,
  extendedWarrantyName: null,
  extendedWarrantySpanishName: null,
  extendedWarrantyFamily: null,
  extendedWarrantyCost: null,
}

export const withExtendedWarrantySnapshot = (
  design: Design,
  snapshot: ExtendedWarrantySnapshot,
): Design => ({
  ...design,
  ...snapshot,
})

export const clearPowurCareWarrantyOnDesign = (design: Design): Design => {
  if (design.extendedWarrantyFamily !== POWUR_CARE_WARRANTY_FAMILY) {
    return design
  }

  return withExtendedWarrantySnapshot(design, CLEARED_EXTENDED_WARRANTY_SNAPSHOT)
}

export const useClearPowurCareWarrantySnapshot = (): (() => void) => {
  const setLocal = useSetRecoilState(designLocalState)
  const setRemote = useSetRecoilState(designRemoteState)

  return useCallback(() => {
    setLocal(clearPowurCareWarrantyOnDesign)
    setRemote(clearPowurCareWarrantyOnDesign)
  }, [setLocal, setRemote])
}
